export default __webpack_public_path__ + "static/media/xequiv-logo.47b8f919.png";